module.exports = __webpack_public_path__ + "img/float-activity-175.8d9dcb29.png";